import { render, staticRenderFns } from "./WelcomeBanner.vue?vue&type=template&id=f9bb45e0"
import script from "./WelcomeBanner.vue?vue&type=script&lang=js"
export * from "./WelcomeBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports